import logo from '../assets/logo.svg';
import flowers from '../assets/flowers.webp';


export default {
  logo,
  flowers
};